export default {
      id: "Icon--delete-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--delete",
      toString: function () {
        return this.url;
      }
    }